<div *ngIf="reportType === 'InDetailCreditNote'">
  <div class="container-fluid" id="print-section">
    <table class="table table-bordered report-table">
      <thead>
        <tr>
          <th colspan="3">Vivek Saptahik</th>
          <th colspan="6">Issue Seller Credit Note Register</th>
          <th colspan="5">Date: {{ currentDate | date: 'dd-MM-yyyy' }}</th>
        </tr>
        <tr>
          <th colspan="2">Datewise</th>
          <th colspan="5">In Details</th>
          <th colspan="3">Date From: {{ startDate | date: 'dd-MM-yyyy' }} To {{ endDate | date: 'dd-MM-yyyy' }}</th>
          <th colspan="4">Page No</th>
        </tr>
        <tr>
          <th>Credit Note No</th>
          <th>CR Date</th>
          <th>Issue Seller Name</th>
          <th>Representative Name</th>
          <th>Office Representative Name</th>
          <th>Issue Name</th>
          <th>Issue Date</th>
          <th>Invoice Number</th>
          <th>Invoice Date</th>
          <th class="num">Invoice Net Amount</th>
          <th class="num">अंक परत</th>
          <th class="num">अंक गहाळ/खराब</th>
          <th class="num">Total <br />Credit Amount</th>
          <th>Remarks</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let data of advtCreditRegiInDetailsFormBeans; let i = index">
          <td>{{ data.credit_voc_no }}</td>
          <td>{{ data.voc_date }}</td>
          <td>{{ data.issue_Seller_Name }}</td>
          <td>{{ data.rep_name }}</td>
          <td>{{ data.office_rep }}</td>
          <td>{{ data.DS_ISSUENAME }}</td>
          <td>{{ data.DS_ISSUEDATE }}</td>
          <td>{{ data.issue_invoice_no }}</td>
          <td>{{ data.issue_invoice_date }}</td>
          <td class="num">{{ data.net_amt }}</td>
          <td class="num">{{ data.tds_amt }}</td>
          <td class="num">{{ data.other_credit_amt }}</td>
          <td class="num">{{ data.credit_v_amt }}</td>
          <td>{{ data.remark }}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="10"><strong>Total:</strong></td>
          <td class="num"><strong>{{ CredittadvtInDTotal }}</strong></td>
          <td class="num"><strong>{{ CredittadvtInDTotalother }}</strong></td>
          <td class="num"><strong>{{ CredittadvtInDTotalAmt }}</strong></td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div style="display: flex; justify-content: flex-end; gap: 16px; margin-right: 22%; margin-top: 10px;">
    <button class="noPrint" mat-raised-button color="primary" (click)="exportExcel('CreditNote_InDetails_Report')">Export</button>
    <button class="noPrint" mat-raised-button color="primary" printSectionId="print-section" ngxPrint>Print</button>
    <button class="noPrint" mat-button mat-dialog-close>Close</button>
  </div>
</div>
